/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {featureFlags} from '@dms/feature-flags';
import {permissions} from '@dms/shared';

export const newVehicleConfiguratorAccess = {
  requiredFeatureFlag: featureFlags.NEW_VEHICLE_CATALOGUE,
  requiredPermission: permissions.newVehicleConfigurationRead,
};

export const getNewVehicleAccess = (
  isFeatureEnabled: boolean,
  canRead: boolean,
  canWrite: boolean
) => ({
  showConfigurations: isFeatureEnabled && canRead,
  showConfigureAction: isFeatureEnabled && canWrite,
});
